<p-toast></p-toast>
<div
  class="surface-0 flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden"
>
  <div class="grid justify-content-center p-2 lg:p-0" style="min-width: 80%">
    <div class="col-12 mt-5 xl:mt-0 text-center">
      <img
        src="assets/layout/images/logo.svg"
        alt="AmigoFarma logo"
        class="mb-5 mr-2"
      />
      <!-- style="width: 81px; height: 60px" -->
    </div>
    <div
      class="col-12 xl:col-6"
      style="
        border-radius: 56px;
        padding: 0.3rem;
        background: linear-gradient(
          180deg,
          var(--primary-color) 10%,
          rgba(33, 150, 243, 0) 30%
        );
      "
    >
      <div
        class="h-full w-full m-0 py-7 px-4"
        style="
          border-radius: 53px;
          background: linear-gradient(
            180deg,
            var(--surface-50) 38.9%,
            var(--surface-0)
          );
        "
      >
        <div class="text-center mb-5">
          <div class="text-900 text-3xl font-medium mb-3">
            Bienvenido a AmigoFarma!
          </div>
          <span class="text-600 font-medium">Inicia sesión para continuar</span>
        </div>
        <form [formGroup]="fg">
          <div class="w-full md:w-10 mx-auto">
            <label for="domain" class="block text-900 text-xl font-medium mb-2"
              >Dominio</label
            >
            <input
              formControlName="domain"
              type="text"
              placeholder="Ingrese su dominio"
              pInputText
              class="w-full mb-3"
              style="padding: 1rem"
              maxlength="20"
            />
            <div *ngIf="fg.get('domain').errors?.minlength">
              <small class="p-error">La longitud minima es 3.</small>
            </div>

            <label
              for="username"
              class="block text-900 text-xl font-medium mb-2"
              >Usuario</label
            >
            <input
              formControlName="username"
              type="text"
              placeholder="Ingrese su Usuario"
              pInputText
              class="w-full mb-3"
              style="padding: 1rem"
              maxlength="20"
            />
            <div *ngIf="fg.get('username').errors?.minlength">
              <small class="p-error">La longitud minima es 3.</small>
            </div>
            <label
              for="password"
              class="block text-900 text-xl font-medium mb-2"
              >Contraseña</label
            >
            <p-password
              formControlName="password"
              placeholder="Ingrese su contraseña"
              styleClass="mb-3"
              [toggleMask]="true"
              [feedback]="false"
            ></p-password>
            <div *ngIf="fg.get('password').errors?.minlength">
              <small class="p-error">La longitud minima es 3.</small>
            </div>

            <!-- <input
              formControlName="password"
              type="password"
              placeholder="Ingrese su Contraseña"
              pInputText
              class="w-full mb-3"
              style="padding: 1rem"
              maxlength="20"
            /> -->
            <button
              (click)="onSubmit()"
              pButton
              pRipple
              [disabled]="fg.invalid"
              label="Ingresar"
              class="w-full p-3 text-xl"
            ></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="loading"
  [modal]="true"
  [style]="{ width: '18vw' }"
  [closeOnEscape]="false"
  [closable]="false"
>
  <div *ngIf="loading" class="flex flex-column" style="flex: 1">
    <div class="text-center">
      <i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
      <h4 class="text-success">Ingresando..</h4>
      <span>Espere se esta validando su cuenta</span>
    </div>
  </div>
</p-dialog>
